import {createAction, props} from '@ngrx/store';
import {GeoData, Profile} from '../profile.model';
import {Location} from '../../location/location.model';

const actionType = '[Profile]';
const createActionType = (type: string) => `${actionType} - ${type}`;

// Profile
export const loadProfile = createAction(createActionType('Load profile'));
export const loadProfileSuccess = createAction(createActionType('Load profile success'), props<{ profile: Profile }>());
export const loadProfileError = createAction(createActionType('Load profile error'));

export const updateProfile = createAction(createActionType('Update profile'), props<{ data: GeoData }>());

// Locations
export const loadLocations = createAction(createActionType('Load locations'));
export const loadLocationsSuccess = createAction(createActionType('Load locations success'), props<{
  locations: Location[]
}>());
export const loadLocationsError = createAction(createActionType('Load locations error'));

// Logout
export const logout = createAction(createActionType('Logout'));
export const logoutSuccess = createAction(createActionType('Logout success'));
export const logoutError = createAction(createActionType('Logout error'));

// Edit profile
export const editProfile = createAction(createActionType('Edit profile'), props<{ data: any }>());
export const editProfileSuccess = createAction(createActionType('Edit profile success'), props<{ response: any }>());
export const editProfileError = createAction(createActionType('Edit profile error'));

// Delete
export const deleteProfile = createAction(createActionType('Delete Profile'));
export const deleteProfileSuccess = createAction(createActionType('Delete Profile success'), props<{
  response: any
}>());
export const deleteProfileError = createAction(createActionType('Delete Profile error'));
